module.exports = __webpack_public_path__ + "media/src/images/icon__check--dark-3cfff5451961450c85749dd04143fd8b.png";